import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-add',
  templateUrl: './image-add.component.html',
  styleUrls: ['./image-add.component.css']
})
export class ImageAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
